/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did Not Finish penalty`)
};

const es_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalización por abandono`)
};

const de_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausfallstrafe`)
};

const nl_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitvalspenalty`)
};

const fr_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pénalité d’abandon`)
};

const it_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalità ritiro`)
};

const pt_br2_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalidade de abandono`)
};

const pt_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalidade de abandono`)
};

const ja_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リタイアペナルティ`)
};

const zh_f1_points_legend_dnf = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退赛惩罚`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_legend_dnf = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_legend_dnf(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_legend_dnf", locale)
	if (locale === "en") return en_f1_points_legend_dnf(inputs)
	if (locale === "es") return es_f1_points_legend_dnf(inputs)
	if (locale === "de") return de_f1_points_legend_dnf(inputs)
	if (locale === "nl") return nl_f1_points_legend_dnf(inputs)
	if (locale === "fr") return fr_f1_points_legend_dnf(inputs)
	if (locale === "it") return it_f1_points_legend_dnf(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_legend_dnf(inputs)
	if (locale === "pt") return pt_f1_points_legend_dnf(inputs)
	if (locale === "ja") return ja_f1_points_legend_dnf(inputs)
	return zh_f1_points_legend_dnf(inputs)
};